import { render, staticRenderFns } from "./ClientsDoc.vue?vue&type=template&id=79d7e02e"
import script from "./ClientsDoc.vue?vue&type=script&lang=js"
export * from "./ClientsDoc.vue?vue&type=script&lang=js"
import style0 from "./ClientsDoc.vue?vue&type=style&index=0&id=79d7e02e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports